module.exports = __webpack_public_path__ + "media/images/sport--Para_Snowboard-271c1957444b86e50d0e1ee960d95ea3.png";